import { useEffect, useState } from "react";
export function useReleaseStatus(releaseDate) {
    const [isReleased, setIsReleased] = useState(false);
    useEffect(() => {
        const check = () => {
            if (!releaseDate)
                return setIsReleased(false);
            const now = Date.now();
            const releaseTime = new Date(releaseDate).getTime();
            setIsReleased(now >= releaseTime);
        };
        check();
        const id = setInterval(check, 1000);
        return () => clearInterval(id);
    }, [releaseDate]);
    return isReleased;
}
